import { CommandHandler } from '.';
import { GridLine, GridLineColumn1, Line } from '..';
import { Interest, Interests } from '../../../data/Interests';

const interestNames = Interests.map(interest => (
    `${interest.name}`
    )).join('\n')

function RenderInterestsTable(){
    return(
        <GridLine>
            <GridLineColumn1>
                {interestNames}
            </GridLineColumn1>
        </GridLine>
    )
}

function RenderInterestsDetail(interest: Interest){
    var responseText = `Name: ${interest?.name}
                Details: ${interest?.details}`;

    return(
        <Line>
            {responseText} 
        </Line>
    )
}

function RenderError(){
    return(
        <Line>
            {`invalid command`}
        </Line>
    )
}
export const InterestsHandler: CommandHandler = {
    process: function (command: string, args: string[]) {
        var error = RenderError();
        var response = {line: {content: error}, overwriteLast: false}

        if(command)
        {
            if(command == 'get')
            {
                var contextName = args.join(' ');
                var interest = Interests.find(t=>  t.name.toLowerCase() == contextName);
                if(interest)
                {
                    var responseDetail = RenderInterestsDetail(interest);
                    response = {line: {content: responseDetail}, overwriteLast: false}
                }                
            }
            else if(command == 'list'){
                var interestTable = RenderInterestsTable();
                response = {line: {content: interestTable}, overwriteLast: false};
            }
        }
        return [
            response
        ]
    }
}